import type { MouseEventHandler, ReactNode } from 'react';
import s from './Button.module.scss';

interface ButtonProps {
  /** Visual variant of the button */
  variant: 'primary' | 'secondary' | 'textOnly';
  /** Type is passed to the html button. Setting the correct type is important for accessibility. */
  type?: 'button' | 'submit' | 'reset';
  /** Function to call on button click */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Classes to apply to html button */
  className?: string;
  /** Button content e.g. text to display */
  children: ReactNode;
  /** Button disable */
  disabled?: boolean;
}

function Button({
  variant,
  type = 'button',
  onClick,
  className = '',
  disabled = false,
  children,
}: ButtonProps) {
  let buttonClasses = s.button;
  buttonClasses = `${buttonClasses} ${className} ${s[variant]}`;

  return (
    <button
      // oxlint-disable-next-line react/button-has-type -- type is constrained by ButtonProps
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default Button;
